var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Modal from "../Modal/Modal";
import ModalHeader from "../Modal/ModalHeader";
import { AlertError } from "../StandardAlerts/StandardAlerts";
import { OkButton } from "../StandardButtons/StandardButtons";
const ErrorPopup = (_a) => {
    var { errorMessage, errorDetail } = _a, modalProps = __rest(_a, ["errorMessage", "errorDetail"]);
    return (_jsxs(Modal, Object.assign({}, modalProps, { children: [_jsx(ModalHeader, { title: "Error", closeModal: modalProps.onModalClosed }), _jsx("div", { className: "modal-body", children: _jsx(AlertError, { message: errorMessage, detail: errorDetail, className: "mb-0" }) }), _jsx("div", { className: "modal-footer", children: _jsx(OkButton, { onClick: () => modalProps.onModalClosed() }) })] })));
};
export default ErrorPopup;
